import { Form, Radio, Checkbox, InputNumber } from "antd";
import { useTranslation } from "react-i18next";

interface PeriodicitySectionProps {
  isRecurrent: boolean;
  recurrenceCheckboxDisabled?: boolean;
}

export const PeriodicitySection: React.FC<PeriodicitySectionProps> = ({
  isRecurrent,
  recurrenceCheckboxDisabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <h3 className="text-base font-semibold mb-2">
        {t("taskHub.modal.periodicity") || ""}
      </h3>
      <div className="grid grid-cols-2 gap-x-4">
        <Form.Item name="is_recurrent" valuePropName="checked">
          <Checkbox disabled={recurrenceCheckboxDisabled}>
            {t("taskHub.modal.enableRecurrence") || ""}
          </Checkbox>
        </Form.Item>
      </div>

      <div className="grid grid-cols-2 gap-x-4">
        {isRecurrent && (
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-1">
              <span className="text-sm font-medium">
                {t("taskHub.modal.repeatEvery") || "Repeat Every"}
              </span>
              <Form.Item name="periodicity_multiple" noStyle>
                <InputNumber min={1} className="!w-16" />
              </Form.Item>
            </div>
            <Form.Item name="periodicity">
              <Radio.Group className="flex flex-col">
                <Radio value="daily">{t("taskHub.modal.day") || "Day"}</Radio>
                <Radio value="weekly">
                  {t("taskHub.modal.week") || "Week"}
                </Radio>
                <Radio value="monthly">
                  {t("taskHub.modal.month") || "Month"}
                </Radio>
                <Radio value="yearly">
                  {t("taskHub.modal.year") || "Year"}
                </Radio>
              </Radio.Group>
            </Form.Item>
          </div>
        )}
      </div>
    </div>
  );
};
